angular.module('zc.zenclerkS')
  .component('zcsProjectBillings', {
    templateUrl: '/templates/zenclerk_s/sites/settings/project_billings.html',
    bindings: {
      project: '='
    },
    controllerAs: 'vm',
    controller: ZcsProjectBillingsController,
  });

ZcsProjectBillingsController.$inject = ['$rootScope', 'Project'];
function ZcsProjectBillingsController($rootScope, Project) {
  const vm = this;

  // actions
  vm.saveProject = saveProject;

  function saveProject(project) {
    Project.update({projectId: project.id}, { project: project })
      .then(res => {
        vm.project = res;
        $rootScope.$emit('projectUpdated', vm.project);
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/settings/project_billings.js